import axios from "axios";

window.axios = axios;
axios.defaults.withCredentials = true;
//axios.defaults.baseURL = 'http://localhost/Documentador-Api/public/api';
axios.defaults.baseURL = 'https://pv.alogistics.mx:5007/api'
axios.defaults.headers = {
    'Content-Type': 'application/json',
}
